import { any, async, fromJSX, nothing, stateful, loadingAsyncState } from "widgets-for-react";
import { initialReactions, validateReactionForm } from "../../components/reactions/reactionsState";
import { BlogPostLayout } from "./blogPostLayout";
import { initialState } from "./blogPostState";
import { reactionsApi } from "../../components/reactions/reactionsApi";
import { previousOrDefault } from "../../../custom_api/api_utils";
import { pushBlogReactionAction } from "../../components/datalayer";
export const BlogPost = (props)=>{
    const api = reactionsApi(props.kind, props.id);
    return stateful()((s0)=>any()([
            fromJSX((setState)=>{
                return BlogPostLayout({
                    ...props,
                    reactionProps: {
                        ...s0,
                        addReaction: (token, reaction, callbackOnSuccess)=>{
                            const validationMessages = validateReactionForm(s0);
                            validationMessages.length == 0 ? addReaction(token, reaction, api, setState, callbackOnSuccess) : setState((s1)=>({
                                    ...s1,
                                    validationMessages
                                }));
                        },
                        updateEditorState: (editorState)=>setState((s0)=>({
                                    ...s0,
                                    editorState: editorState
                                })),
                        updateAuthorEmail: (authorEmail)=>setState((s0)=>({
                                    ...s0,
                                    authorEmail
                                })),
                        updateAuthorScreenName: (authorScreenName)=>setState((s0)=>({
                                    ...s0,
                                    authorScreenName
                                })),
                        updateValidationMessages: (messages)=>setState((s0)=>({
                                    ...s0,
                                    validationMessages: messages
                                })),
                        pushDataLayer: pushBlogReactionAction(props.pageTitle)
                    }
                });
            }),
            async(nothing, {
                key: 'reactionsLoader'
            })(s0.reactions).map((reactionsUpdater)=>(s1)=>{
                    const reactions = reactionsUpdater(s1.reactions);
                    return {
                        ...s1,
                        reactions
                    };
                })
        ]).map((a)=>a(s0)))(initialState(api)).run((_)=>{});
};
const addReaction = async (token, reaction, api, setState, callbackOnSuccess)=>{
    setState((s0)=>({
            ...s0,
            submitting: true
        }));
    const message = await api.postReaction(token, reaction).then((result)=>{
        if (result.kind != 'result') throw result.kind;
        const m = {
            kind: "success",
            message: "Je bericht is met succes geplaatst."
        };
        return m;
    }).catch((e)=>{
        console.error('Submitting form failed', e);
        const m = {
            kind: "error",
            message: "Er is iets mis gegaan tijdens het plaatsen van het bericht"
        };
        return m;
    });
    if (callbackOnSuccess && message.kind == 'success') callbackOnSuccess();
    setState((s0)=>{
        const success = message.kind == 'success';
        const nextState = success ? initialState(api) : s0;
        const { authorScreenName, authorEmail, editorState } = nextState;
        return {
            ...s0,
            validationMessages: [
                message
            ],
            submitting: false,
            authorScreenName,
            authorEmail,
            editorState,
            reactions: loadingAsyncState(api.getReactions, previousOrDefault(s0.reactions, initialReactions))
        };
    });
};
